import { EFieldMenuActionType } from '@/dealroom/fields/context-menu/types/enums/field-menu-action-type';
import { EFieldType } from '@/dealroom/fields/types/enums/field-type';
import {
  singleFieldActionsBase,
  multipleFieldActionsBase,
} from '@/dealroom/fields/constants/field-actions';
import { IFieldMenuAction } from '@/dealroom/fields/context-menu/types/field-menu-action';
import { IField } from '@/dealroom/fields/types/field';

export class ContextMenuHelper {
  static singleFieldActions(field: IField, isTemplate: boolean): IFieldMenuAction[] {
    let actions: IFieldMenuAction[] = singleFieldActionsBase;
    const isEditable: boolean = isTemplate || field.isEditable;
    if (!isEditable) {
      actions = ContextMenuHelper.filterNotEditableActions(actions, field.type);
    }
    switch (field.type) {
      case EFieldType.Merge:
        actions = actions.filter(
          (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.Recipients
        );
        break;
      case EFieldType.Check:
        actions = actions.filter(
          (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.TextSize
        );
        break;
      case EFieldType.Link:
        actions = actions.filter(
          (action: IFieldMenuAction) =>
            ![EFieldMenuActionType.TextSize, EFieldMenuActionType.Recipients].includes(action.type)
        );
        break;
      case EFieldType.Initials:
        actions = isTemplate
          ? actions
          : actions.filter(
              (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.Settings
            );
        break;
    }
    return ContextMenuHelper.sortFieldActions(actions);
  }

  static multipleFieldActions(fields: IField[], isTemplate: boolean): IFieldMenuAction[] {
    let actions: IFieldMenuAction[] = multipleFieldActionsBase;

    const isEditable: boolean = isTemplate || fields.every((field: IField) => field.isEditable);
    if (!isEditable) {
      actions = ContextMenuHelper.filterNotEditableActions(actions);
    }

    const fieldsEligableToTextSize: boolean = fields.every(
      (field: IField) => ![EFieldType.Link, EFieldType.Check].includes(field.type)
    );
    if (!fieldsEligableToTextSize) {
      actions = actions.filter(
        (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.TextSize
      );
    }

    const fieldsEligableToAssign: boolean = fields.every(
      (field: IField) => ![EFieldType.Link, EFieldType.Merge].includes(field.type)
    );
    if (!fieldsEligableToAssign) {
      actions = actions.filter(
        (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.Recipients
      );
    }

    return ContextMenuHelper.sortFieldActions(actions);
  }

  private static filterNotEditableActions(
    actions: IFieldMenuAction[],
    fieldType?: EFieldType
  ): IFieldMenuAction[] {
    actions = actions.filter(
      (action: IFieldMenuAction) =>
        ![
          EFieldMenuActionType.Duplicate,
          EFieldMenuActionType.Move,
          EFieldMenuActionType.TextSize,
          EFieldMenuActionType.TextSize,
          EFieldMenuActionType.Delete,
          EFieldMenuActionType.Align,
        ].includes(action.type)
    );
    if (!fieldType || (fieldType !== EFieldType.Check && fieldType !== EFieldType.Dropdown)) {
      actions = actions.filter(
        (action: IFieldMenuAction) => action.type !== EFieldMenuActionType.Settings
      );
    }
    return actions;
  }

  private static sortFieldActions(actions: IFieldMenuAction[]): IFieldMenuAction[] {
    return actions.sort((a: IFieldMenuAction, b: IFieldMenuAction) => a.type - b.type);
  }
}
